module.exports = __webpack_public_path__ + "static/media/ebay.53eec62d.svg";